var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-table-cell-image"},[_c('common-image',{attrs:{"image":_vm.src,"href":_vm.href,"is-absolute":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }